import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import Input from "@mostrans/web-components/components/base/Input";
import { Box, Card, CardContent } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Countdown from "react-countdown";
import { useSetState } from "react-use";
import { sendOTP } from "../../graphql/mutations";
import { validateOTP } from "../../graphql/query";
import { toastError, toastSuccess } from "../../shared/helpers";
import ChangeVerification from "./ChangeVerification";
import CreatePassword from "./CreatePassword";

const VerifyOTP = ({ otp, data, setData }) => {
  const client = useApolloClient();
  const input1 = useRef();
  const input2 = useRef();
  const input3 = useRef();
  const input4 = useRef();
  const values = {
    email: data.email,
    phone_number: data.phone_number,
    full_name: data.full_name,
  };
  const [state, setState] = useSetState({
    value: null,
    input1: null,
    input2: null,
    input3: null,
    input4: null,
  });
  const [isResend, setIsResend] = useState(false);
  const [createpassword, setCreatepassword] = useState(false);
  const [changeVerification, setChangeVerification] = useState(false);

  useEffect(() => {
    input1.current.focus();
  }, []);

  const countdown = ({ seconds, completed }) => {
    if (completed) {
      setIsResend(false);
      return <></>;
    } else {
      return <span>{seconds}</span>;
    }
  };

  const handleKey = (e) => {
    if (e.key === "Backspace" || e.key === "Delete") {
      const prev = e.target.tabIndex - 2;
      if (prev > -1) {
        e.target.form.elements[prev].focus();
      }
    } else {
      const next = e.target.tabIndex;
      if (next < 4) {
        e.target.form.elements[next].focus();
      }
    }
  };

  const handleSubmit = async () => {
    var value = "" + state.input1 + state.input2 + state.input3 + state.input4;
    const validate = await validateOTP(client, parseInt(value), values.email);
    if (validate !== true) {
      toastError("Error, OTP Code not valid!");
    } else {
      toastSuccess("Success, please create your password!");
      setCreatepassword(true);
    }
  };

  const handleResendOTP = async () => {
    setIsResend(true);
    const resend = await sendOTP(client, values);
    if (resend.status !== "000") {
      toastError("Error, Try again later!");
    } else {
      toastSuccess("Success, please check your email or whatsapp!");
    }
  };

  const handleInput = (key, e) => {
    if (e.target.value.length > 1) {
      e.target.value = e.target.value.slice(1);
    }

    setState({ [key]: e.target.value });
  };

  return (
    <React.Fragment>
      {createpassword ? (
        <CreatePassword data={data} />
      ) : changeVerification ? (
        <ChangeVerification
          setChangeVerification={setChangeVerification}
          data={data}
          setData={setData}
        />
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          textAlign="center"
          width="360px">
          <Card>
            <CardContent>
              <p className="font-weight-w500 font-size-h4 mb-1">Enter Code Verification</p>
              <p className="font-weight-w400 font-size-main text-textSecondary mb-1">
                Code has been sent to Email{" "}
                <strong className="text-text font-weight-w500">{data.email}</strong> and WhatsApp{" "}
                <strong className="text-text font-weight-w500">{data.phone_number}</strong>
              </p>
              <p
                className="text-primary-main font-size-main font-weight-w600"
                style={{ cursor: "pointer" }}
                onClick={() => setChangeVerification(true)}>
                Change
              </p>
              <Box my={4}>
                <form
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    textAlign: "center",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    gap: "0",
                  }}>
                  <Input
                    type="number"
                    ref={input1}
                    min="0"
                    max="9"
                    value={state.first}
                    onKeyUp={(e) => handleKey(e)}
                    maxLength="1"
                    tabIndex={1}
                    onChange={(e) => handleInput("input1", e)}
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      padding: "5px",
                      gap: "5px",
                      width: "50px",
                      height: "50px",
                      fontSize: "27px",
                      fontWeight: "500",
                      textAlign: "center",
                    }}
                  />
                  <Input
                    type="number"
                    min="0"
                    max="9"
                    ref={input2}
                    value={state.sec}
                    onKeyUp={(e) => handleKey(e)}
                    maxLength={1}
                    tabIndex={2}
                    onChange={(e) => handleInput("input2", e)}
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      padding: "5px",
                      gap: "5px",
                      width: "50px",
                      height: "50px",
                      fontSize: "27px",
                      fontWeight: "500",
                      textAlign: "center",
                    }}
                  />
                  <Input
                    type="number"
                    min="0"
                    max="9"
                    ref={input3}
                    value={state.third}
                    onKeyUp={(e) => handleKey(e)}
                    maxLength={1}
                    tabIndex={3}
                    onChange={(e) => handleInput("input3", e)}
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      padding: "5px",
                      gap: "5px",
                      width: "50px",
                      height: "50px",
                      fontSize: "27px",
                      fontWeight: "500",
                      textAlign: "center",
                    }}
                  />
                  <Input
                    type="number"
                    min="0"
                    max="9"
                    ref={input4}
                    value={state.fourth}
                    onKeyUp={(e) => handleKey(e)}
                    maxLength={1}
                    tabIndex={4}
                    onChange={(e) => handleInput("input4", e)}
                    style={{
                      boxSizing: "border-box",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      padding: "5px",
                      gap: "5px",
                      width: "50px",
                      height: "50px",
                      fontSize: "27px",
                      fontWeight: "500",
                      textAlign: "center",
                    }}
                  />
                </form>
              </Box>
              <Box
                display="flex"
                textAlign="center"
                flexDirection="row"
                alignItems="flex-start"
                justifyContent="center"
                gap="16px">
                <p className="font-weight-w400 text-textSecondary font-size-main mb-2">
                  Didn't receive code OTP?
                </p>
                {isResend ? (
                  <p className="text-textSecondary font-size-main">
                    Please wait &nbsp;
                    <Countdown date={Date.now() + 30000} renderer={countdown} />
                    &nbsp;second
                  </p>
                ) : (
                  <p
                    className="text-primary-main font-size-main font-weight-w600 "
                    onClick={handleResendOTP}
                    style={{ cursor: "pointer" }}>
                    Resend
                  </p>
                )}
              </Box>
              <Button
                onClick={handleSubmit}
                variant="contained"
                color="primary"
                style={{ width: "100%" }}>
                Verify
              </Button>
            </CardContent>
          </Card>
        </Box>
      )}
    </React.Fragment>
  );
};

export default VerifyOTP;
